import { isCurrency, isFloat, isDecimal, isInt, isAlphanumeric, isEmpty } from 'validator';

const stringify = (value) => {
    return value ? value.toString() : "";
}
const currencyValidator = (value) => {
    value = stringify(value);
    return isCurrency(value, { digits_after_decimal: [1, 2] }) &&
        isFloat(value, { min: 0.01 });
};

const nonDecimalCurrencyValidator = (value) => {
    value = stringify(value);
    return isInt(value, { min: 1 });
};
const nonDecimal0CurrencyValidator = (value) => {
    value = stringify(value);
    return isInt(value, { min: 0 });
};

const percentageValidator = (value) => {
    /* return isDecimal(value, { decimal_digits: '1,2' }) &&
     isFloat(value, { min: 0.01, max: 100 }); */
    value = stringify(value);
    return isInt(value, { min: 1, max: 99 });
};

const quantityValidator = (value) => {
    value = stringify(value);
    return isInt(value, { min: 1 });
};

const phoneValidator = (value) => {
    value = stringify(value);
    return isInt(value) & value.length >= 8;
};

const timeValidator = (value) => {
    value = stringify(value);
    return isInt(value) & (value.length >= 0 || value.length >= 50);
};

const companyNameValidator = (value) => {
    // any alpha numeric with spaces
    return isAlphanumeric(value.replace(/\s+/g, ''), 'en-US');
};

const empty = (value) => {
    return isEmpty(value, { ignore_whitespace: true });
};

const isBlank = (str) => {
    if (str == undefined || 'undefined' == typeof str || null == str || '' == str || (str + '').trim().length == 0 || !str) {
        return true;
    }
    return false;
};

const isNotEmptyAndFloat = (str) => {
    if (isBlank(str)) {
        return true;
    }
    return !isBlank(str) && (Number(str) > 0) && isFloat(str);
};

const isNotEmptyAndInt = (str) => {
    if (isBlank(str)) {
        return true;
    }
    return !isBlank(str) && (Number(str) > 0) && (isInt(str) || isDecimal(str) || isFloat(str));
};

const isNotRoundNumber = (value) => {
    if (value) {
        var numVal = Number(value);
        if (numVal < 0) {
            return true;
        }
        if (numVal % 1 !== 0) {
            return true;
        }
        /*if(numVal > 999999){
         return true;
         }*/
    }
    return false;
};

const isNotEmptyAndFloatWithZero = (str) => {
    if (isBlank(str)) {
        return true;
    }
    return !isBlank(str) && (Number(str) >= 0) && isFloat(str);
};

const isValidOrderCsv = (value) => {
    return !/[^a-zA-Z0-9\-\,]/.test(value)
}

const isValidFileName = (value) => {
    return !(new RegExp('^[^\\/?%*:|"<>\.]+$').test(value))
}

export {
    empty,
    currencyValidator,
    nonDecimalCurrencyValidator,
    nonDecimal0CurrencyValidator,
    percentageValidator,
    companyNameValidator,
    quantityValidator,
    phoneValidator,
    timeValidator,
    isBlank,
    isNotEmptyAndFloat,
    isNotEmptyAndInt,
    isNotRoundNumber,
    isNotEmptyAndFloatWithZero,    
    isValidOrderCsv,
    isValidFileName
};